<template>
  <div class="user-center">
    <!-- 公共头部组件 -->
    <CommonHeader />

    <!-- 用户信息横幅区域 -->
    <div class="user-banner">
      <div class="user-banner-content">
        <!-- 最后登录时间 + 协会会员信息修改 -->
        <div class="last-login-row">
          <div class="last-login">
            {{ $t('userCenter.lastLoginTime') }}{{ userInfo.lastLoginTime }}
          </div>
          <div
            v-if="isAssociationMember"
            class="member-edit-wrapper"
          >
            <span
              class="member-status-tag"
              :class="memberStatusTagClass"
            >
              {{ associationMemberStatusText }}
            </span>
            <button
              type="button"
              class="member-edit-btn"
              @click="onMemberInfoEdit"
            >
              <span>{{ $t('userCenter.associationMember') }}</span>
              <el-icon class="member-edit-icon">
                <Edit />
              </el-icon>
            </button>
          </div>
        </div>

        <!-- 用户头像和基本信息 -->
        <div class="user-profile">
          <div class="user-avatar-wrapper">
            <img
              :src="userInfo.avatar"
              :alt="$t('userCenter.avatarAlt')"
              class="user-avatar-large"
            >
            <!-- 头像编辑功能 -->
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="handleAvatarUpload"
            >
              <div class="avatar-edit-overlay">
                <el-icon class="edit-icon">
                  <Camera />
                </el-icon>
                <span class="edit-text">{{ $t('userCenter.changeAvatar') }}</span>
              </div>
            </el-upload>
          </div>
          <div class="user-basic-info">
            <!-- 个人用户显示 -->
            <template v-if="$auth.hasPersonalType()">
              <div class="user-name-row">
                <span class="label">{{ $t('userCenter.nickname') }}</span>
                <span
                  v-if="!isEditingNickname"
                  class="value nickname-display"
                  @click="startEditNickname"
                >
                  {{ editNickname || formData.nickName || userInfo.name }}
                  <el-icon class="edit-icon-inline"><Edit /></el-icon>
                </span>
                <div
                  v-else
                  class="nickname-edit-wrapper"
                >
                  <el-input
                    v-model="editNickname"
                    class="nickname-input"
                    :placeholder="$t('userCenter.nicknamePlaceholder')"
                    maxlength="20"
                    @blur="handleNicknameBlur"
                    @keyup.enter="saveNickname"
                  />
                  <el-button
                    type="primary"
                    size="small"
                    class="save-nickname-btn"
                    @click="saveNickname"
                  >
                    {{ $t('userCenter.save') }}
                  </el-button>
                  <el-button
                    size="small"
                    class="cancel-nickname-btn"
                    @click="cancelEditNickname"
                  >
                    {{ $t('userCenter.cancel') }}
                  </el-button>
                </div>
              </div>
              <div class="user-name-row">
                <span class="label">{{ $t('userCenter.realName') }}</span>
                <span class="value">{{ formData.realName || userInfo.name }}</span>
              </div>
            </template>
            <!-- 企业用户显示 -->
            <template v-else>
              <div class="user-name-row enterprise-name-row">
                <span class="label">{{ $t('userCenter.enterpriseName') }}</span>
                <span
                  class="value enterprise-name-value"
                  :title="userInfo.enterpriseName"
                >{{ userInfo.enterpriseName }}</span>
              </div>
              <div class="user-name-row">
                <span
                  v-if="$auth.isChannel()"
                  class="label"
                >{{ $t('userCenter.channelName') }}</span>
                <span
                  v-else-if="$auth.isOrganization()"
                  class="label"
                >{{ $t('userCenter.organizationName') }}</span>
                <span class="value">{{ userInfo.channelOrOrganizationName }}</span>
              </div>
            </template>
            <div class="user-info-row">
              <span class="label">{{ $t('userCenter.registerTime') }}</span>
              <span class="value">{{ userInfo.createTime }}</span>
            </div>
            <!-- 会员等级图标 -->
            <div class="vip-badges">
              <!-- <div
                v-for="i in 10"
                :key="i"
                class="vip-badge"
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIP会员广告卡片 -->
    <!-- <div class="vip-banner-section">
      <div class="vip-banner-content">
        <div class="vip-card">
          <div class="vip-info">
            <div class="vip-title">
              三种大会员方案，满足不同需求主体
            </div>
            <div class="vip-subtitle">
              从基础管理到全球服务，助力企业全方位保护版权资产
            </div>
          </div>
          <div class="vip-benefits">
            <div class="vip-benefit">
              <img
                src="@/assets/icons/vip-benefits1.png"
                alt=""
                class="vip-benefit-icon"
              >
              <div class="vip-benefit-text">
                <div class="vip-benefit-title">
                  版权保护
                </div>
                <div class="vip-benefit-desc">
                  安全合规
                </div>
              </div>
            </div>
            <div class="vip-benefit">
              <img
                src="@/assets/icons/vip-benefits2.png"
                alt=""
                class="vip-benefit-icon"
              >
              <div class="vip-benefit-text">
                <div class="vip-benefit-title">
                  高效管理
                </div>
                <div class="vip-benefit-desc">
                  提升效率
                </div>
              </div>
            </div>
            <div class="vip-benefit">
              <img
                src="@/assets/icons/vip-benefits3.png"
                alt=""
                class="vip-benefit-icon"
              >
              <div class="vip-benefit-text">
                <div class="vip-benefit-title">
                  全球服务
                </div>
                <div class="vip-benefit-desc">
                  专业支持
                </div>
              </div>
            </div>
          </div>
          <el-button
            class="vip-btn"
            @click="handleRightsMenuClick({ key: 'platformVip' })"
          >
            查看权益
            <el-icon class="vip-btn-icon">
              <ArrowRight />
            </el-icon>
          </el-button>
        </div>
      </div>
    </div> -->

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="content-wrapper">
        <!-- 左侧导航菜单 -->
        <div
          v-if="activeTab === 'account' || activeTab === 'rights'"
          class="sidebar-menu"
        >
          <div class="menu-section">
            <!-- <div class="menu-title">个人信息</div> -->
            <!-- 账号管理菜单 -->
            <template v-if="activeTab === 'account'">
              <template
                v-for="item in accountMenuItems"
                :key="item.key"
              >
                <div
                  class="menu-item"
                  :class="{ active: activeMenu === item.key && !isCreatingNewEnterprise }"
                  @click="handleMenuClick(item)"
                >
                  <span class="menu-label">{{ item.label }}</span>
                  <span
                    v-if="item.key === 'personalAuth'"
                    class="verify-status"
                    :class="{ unverified: isVerifiedPersonal === '0', verifying: isVerifiedPersonal === '1', verified: isVerifiedPersonal === '2', rejected: isVerifiedPersonal === '3' }"
                  >{{ getIsVerifiedText(isVerifiedPersonal) }}</span>
                  <span
                    v-if="item.key === 'enterpriseAuth'"
                    class="verify-status"
                    :class="{ unverified: isVerifiedEnterprise === '0', verifying: isVerifiedEnterprise === '1', verified: isVerifiedEnterprise === '2', rejected: isVerifiedEnterprise === '3' }"
                  >{{ getIsVerifiedText(isVerifiedEnterprise) }}</span>
                </div>
                <!-- 企业列表：仅查看/编辑详情，不做身份切换 -->
                <div
                  v-if="item.key === 'enterpriseAuth' && enterpriseList.length"
                  class="enterprise-identity-list"
                >
                  <div
                    v-for="ent in enterpriseList"
                    :key="getEnterpriseIdentityId(ent)"
                    class="enterprise-identity-item"
                    :class="{
                      selected: !isCreatingNewEnterprise && String(selectedEnterpriseId) === String(getEnterpriseIdentityId(ent))
                    }"
                    @click.stop="handleSelectEnterprise(ent)"
                  >
                    <span
                      class="ent-radio"
                      :class="{
                        checked: !isCreatingNewEnterprise && String(selectedEnterpriseId) === String(getEnterpriseIdentityId(ent))
                      }"
                    />
                    <span
                      class="ent-name"
                      :title="getEnterpriseIdentityName(ent)"
                    >{{ getEnterpriseIdentityName(ent) }}</span>
                  </div>
                </div>
              </template>
            </template>
            <!-- 我的权益菜单 -->
            <template v-else-if="activeTab === 'rights'">
              <div
                v-for="item in rightsMenuItems"
                :key="item.key"
                class="menu-item"
                :class="{ active: activeRightsMenu === item.key }"
                @click="handleRightsMenuClick(item)"
              >
                <span class="menu-label">{{ item.label }}</span>
              </div>
            </template>
          </div>
          
          <!-- 根据状态显示不同的按钮 -->
          <template v-if="activeTab === 'account'">
            <!-- 认证新企业账号：个人已实名后可新增企业认证（不做身份切换） -->
            <el-button
              v-if="canShowCreateEnterpriseButton"
              class="logout-btn create-enterprise-btn"
              @click="handleCreateNewEnterprise"
            >
              {{ $t('userCenter.btn.createEnterprise') }}
            </el-button>
            <template v-if="personalUserOrdinaryAdminEnterpriseId">
              <el-button
                class="logout-btn exit-admin-btn"
                @click="handleExitEnterpriseAdmin"
              >
                {{ $t('userCenter.btn.exitAdmin') }}
              </el-button>
            </template>
            <!-- 渠道代理状态：显示两个按钮 -->
            <template v-if="proxyRelationInfo.hasAuthorizedProxy">
              <template v-if="proxyRelationInfo.agentEntType === '2'">
                <el-button
                  class="logout-btn cancel-proxy-btn"
                  @click="handleChannelOperation('cancelChannelProxy')"
                >
                  {{ $t('userCenter.btn.cancelChannelProxy') }}
                </el-button>
                <el-button
                  class="logout-btn"
                  @click="handleChannelOperation('exitChannel')"
                >
                  {{ $t('userCenter.btn.exitChannel') }}
                </el-button>
              </template>
              <!-- 机构代理状态：显示退出机构按钮 -->
              <el-button
                v-else-if="proxyRelationInfo.agentEntType === '1'"
                class="logout-btn"
                @click="handleChannelOperation('exitInstitution')"
              >
                {{ $t('userCenter.btn.exitInstitution') }}
              </el-button>
            </template>
            <!-- 已加入渠道（未授权代理）：显示退出渠道按钮,因为机构没有授权代理功能,所以只能退出渠道 -->
            <el-button
              v-else-if="proxyRelationInfo.hasJoined"
              class="logout-btn"
              @click="handleChannelOperation('exitChannel')"
            >
              {{ $t('userCenter.btn.exitChannel') }}
            </el-button>
            <!-- 未加入任何渠道：显示加入渠道按钮（渠道和机构角色不显示，未实名认证不显示） -->
            <el-button
              v-else-if="canShowJoinChannelButton"
              class="logout-btn"
              @click="handleJoinChannel"
            >
              {{ $t('userCenter.btn.joinChannel') }}
            </el-button>
            <!-- 展示所属渠道/机构 -->
            <div
              v-if="channelRelationText"
              class="channel-relation-text"
            >
              {{ channelRelationText }}
            </div>
          </template>

          <template v-if="activeTab === 'rights'">
            <el-button
              class="logout-btn"
              @click="handlePublicAction"
            >
              {{ $t('userCenter.btn.copyrightPublicAction') }}
            </el-button>
          </template>
        </div>

        <!-- 右侧内容区域 -->
        <div class="content-area">
          <!-- 标签页导航 -->
          <div class="tabs-nav">
            <div
              v-for="tab in tabs"
              :key="tab.key"
              class="tab-item"
              :class="{ active: activeTab === tab.key }"
              @click="handleTabClick(tab)"
            >
              {{ tab.label }}
            </div>
          </div>
          
          <router-view v-slot="{ Component }">
            <component 
              :is="Component" 
              @submit-success="handleIdentitySubmitSuccess"
              @tab-change="handleTabChange"
            />
          </router-view>
        </div>
      </div>
    </div>

    <!-- 公共底部组件 -->
    <CommonFooter />

    <!-- 加入渠道模态对话框 -->
    <JoinChannelDialog
      v-model="joinChannelDialogVisible"
      @success="handleJoinChannelSuccess"
    />

    <!-- 协会会员信息编辑弹窗 -->
    <AssociationMemberInfoEdit
      v-model="memberInfoEditVisible"
      @success="onMemberInfoEditSuccess"
    />
  </div>
</template>

<script>
import { ElMessage, ElLoading } from 'element-plus'
import { ArrowRight, Camera, Edit } from '@element-plus/icons-vue'
import { getMemberUnitShowStatusLabel, getMemberUnitShowStatusClassSuffix } from '@/enums/MemberUnitShowStatusEnum'
import CommonHeader from '@/views/commonHeaderAndFooter/header.vue'
import CommonFooter from '@/views/commonHeaderAndFooter/footer.vue'
import JoinChannelDialog from './JoinChannelDialog.vue'
import AssociationMemberInfoEdit from './account/AssociationMemberInfoEdit.vue'
import { getEnterpriseBySuperAdminId, updateUserNickName, updateCurrentAvatar, getProxyRelationInfo, clientQuit, clientCancelChannelAgency, exitEnterpriseAdmin } from '@/api/userCenter'
import { getCurrentEnterprise } from '@/api/enterprise'
import { getCurrentUserDetail } from '@/api/login'
import { uploadImage } from '@/api/utils/file'
import { getMemberUnitInfoByEntId } from '@/api/memberUnit'
import { showEnhancedConfirmDialog } from '@/utils/messageUtils'

export default {
  name: 'UserCenter',
  components: {
    CommonHeader,
    CommonFooter,
    JoinChannelDialog,
    AssociationMemberInfoEdit,
    ArrowRight,
    Camera,
    Edit
  },
  data() {
    return {
      // 用户信息
      userInfo: {
        avatar: '',
        name: '',
        mainBodyId: null,
        createTime: '',
        lastLoginTime: '',
        mainBodyType: '', // 用户类型：person-个人，enterprise-企业
        enterpriseName: '', // 企业名称
        channelOrOrganizationName: '' 
      },
      // 表单数据（传递给子组件）
      formData: {
        avatar: '',
        nickName: '',
        realName: '',
        phone: '',
        email: ''
      },
      // 个人认证状态
      isVerifiedPersonal: '0', // '0': 未认证, '1': 认证中, '2': 已认证, '3': 未通过
      personalUserOrdinaryAdminEnterpriseId: null,
      personalUserOrdinaryAdminEnterpriseName: '',
      // 企业认证状态：0-未认证, 1-认证中, 2-已认证, 3-未通过
      isVerifiedEnterprise: '0',
      // 个人超管名下企业列表（侧边栏查看/编辑用，不做身份切换）
      enterpriseList: [],
      selectedEnterpriseId: null,
      isCreatingNewEnterprise: false,
      // 编辑状态
      isEditingNickname: false,
      editNickname: '',
      originalNickname: '',
      uploadingAvatar: false,
      // 加入渠道相关
      joinChannelDialogVisible: false,
      // 代理关系信息
      proxyRelationInfo: {
        hasAuthorizedProxy: false, // 是否授权代理
        hasJoined: false, // 是否加入渠道/机构
        agentEntName: '', // 代理方企业名称
        agentEntType: '', // 代理方企业类型: 1机构企业 2渠道企业
        agentEntId: null // 代理方企业ID
      },
      // 当前账号是否为协会会员（企业且已入会才为 true）
      isAssociationMember: false,
      // 协会会员展示状态 null
      associationMemberStatus: null,
      // 协会会员信息编辑弹窗
      memberInfoEditVisible: false
    }
  },
  computed: {
    associationMemberStatusText() {
      console.log(this.associationMemberStatus)
      return getMemberUnitShowStatusLabel(this.associationMemberStatus)
    },
    memberStatusTagClass() {
      return `member-status-tag--${getMemberUnitShowStatusClassSuffix(this.associationMemberStatus)}`
    },
    tabs() {
      return [
        'account',
        'rights',
        'myRecord',
        'order',
        'invoice',
        'myConsultation',
        'activity',
        // 'collection', // 我的收藏：暂不开放
        'message'
      ].map(key => ({
        key,
        label: this.$t(`userCenter.tabs.${key}`)
      }))
    },
    activeTab() {
      const path = this.$route.path;
      if (path.includes('/account/')) return 'account';
      if (path.includes('/rights/')) return 'rights';
      if (path.includes('/my-record')) return 'myRecord';
      if (path.includes('/invoice')) return 'invoice';
      if (path.includes('/order')) return 'order';
      if (path.includes('/my-consultation')) return 'myConsultation';
      if (path.includes('/activity')) return 'activity';
      // if (path.includes('/collection')) return 'collection'; // 我的收藏：暂不开放
      if (path.includes('/message')) return 'message';
      return 'account';
    },
    activeMenu() {
      if (this.activeTab !== 'account') return '';
      const path = this.$route.path;
      const segment = path.split('/').pop();
      return segment.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    },
    activeRightsMenu() {
      if (this.activeTab !== 'rights') return '';
      const path = this.$route.path;
      const segment = path.split('/').pop();
      return segment.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    },
    // 账号管理左侧菜单
    accountMenuItems() {
      const allMenuItems = [
        { key: 'personalAuth', label: this.$t('userCenter.accountMenu.personalAuth') },
        { key: 'enterpriseAuth', label: this.$t('userCenter.accountMenu.enterpriseAuth') },
        { key: 'assessment', label: this.$t('userCenter.accountMenu.assessment') },
        { key: 'management', label: this.$t('userCenter.accountMenu.management') },
        { key: 'resetPassword', label: this.$t('userCenter.accountMenu.resetPassword') },
        { key: 'myApproval', label: this.$t('userCenter.accountMenu.myApproval') }
      ]
      
      // 个人用户显示：个人信息、个人实名认证、企业身份认证、我的授权
      if (this.$auth.hasPersonalType()) {
        return allMenuItems.filter(item => 
          ['personalInfo', 'personalAuth', 'enterpriseAuth', 'myApproval'].includes(item.key)
        )
      }
      if(this.$auth.hasEnterpriseType()){
         // 企业用户显示：企业身份认证、企业管理员（仅限超级管理员）、我的授权
        return allMenuItems.filter(item => {
          if (item.key === 'management' || item.key === 'resetPassword') {
            return this.$auth.isSuperAdmin()
          }
          return ['enterpriseAuth', 'myApproval'].includes(item.key)
        })
      }
      return []
    },
    /**
     * 不为机构或者渠道
     */
     isNotChannelOrOrganization() {
      return !this.$auth.isChannel() && !this.$auth.isOrganization()
    },
    /**
     * 是否显示「加入渠道」按钮：非渠道/机构角色且已完成实名认证
     */
    canShowJoinChannelButton() {
      return this.isNotChannelOrOrganization && this.$auth.isIdentityVerified()
    },
    /**
     * 是否显示「认证新企业账号」：个人已实名，且至少已有一家企业认证通过
     * （未做第一家企业认证时不显示，引导走「企业身份认证」本身）
     */
    canShowCreateEnterpriseButton() {
      return (
        this.$auth.hasPersonalType() &&
        this.isVerifiedPersonal === '2' &&
        this.isVerifiedEnterprise === '2'
      )
    },
    // 权益菜单项
    rightsMenuItems() {
      return [
        { key: 'freeRights', label: this.$t('userCenter.rightsMenu.freeRights') },
        { key: 'platformVip', label: this.$t('userCenter.rightsMenu.platformVip') },
        // { key: 'copyrightBusiness', label: this.$t('userCenter.rightsMenu.copyrightBusiness') },
        // { key: 'inviteUser', label: this.$t('userCenter.rightsMenu.inviteUser') },
        // { key: 'educationTraining', label: this.$t('userCenter.rightsMenu.educationTraining') }
      ]
    },
   
    // 显示渠道或机构名称
    channelRelationText() {
      let data = this.proxyRelationInfo
      let agentEntName = data.agentEntName
      let agentEntType = data.agentEntType
      let hasJoined = data.hasJoined
      // 如果有代理关系且有企业名称，才显示
      if (agentEntName && hasJoined) {
        return this.$t('userCenter.channelRelation', {
          type: agentEntType === '1'
            ? this.$t('userCenter.organizationType')
            : this.$t('userCenter.channelType'),
          name: agentEntName
        })
      }
      return ''
    }
  },
  mounted() {
    // 加载用户信息
    this.loadUserInfo()
    // 加载代理关系信息
    this.loadProxyRelationInfo()
  },
  methods: {
    /** 打开协会会员信息修改弹窗 */
    onMemberInfoEdit() {
      this.memberInfoEditVisible = true
    },
    async onMemberInfoEditSuccess() {
      if (this.isAssociationMember) {
        try {
          const response = await getMemberUnitInfoByEntId(this.userInfo?.mainBodyId)
          this.associationMemberStatus = response.data.showStatus
        } catch (e) {
          console.error('刷新协会会员展示状态失败:', e)
        }
      }
    },
    /**
     * 将驼峰命名转换为短横线命名
     */
    toKebabCase(str) {
      return str.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);
    },
    
    /**
     * 处理标签页点击
     */
    handleTabClick(tab) {
      if (['activity' /* , 'collection' */].includes(tab.key)) {
        //ElMessage.info(this.$t('userCenter.msg.underDevelopment'))
      }

      if (tab.key === 'account') {
        const firstMenu = this.accountMenuItems.length > 0 ? this.accountMenuItems[0].key : 'placeholder';
        if (firstMenu === 'placeholder') {
           this.$router.push('/user-center/placeholder');
        } else {
           this.$router.push(`/user-center/account/${this.toKebabCase(firstMenu)}`);
        }
      } else if (tab.key === 'rights') {
        const firstMenu = this.rightsMenuItems.length > 0 ? this.rightsMenuItems[0].key : 'placeholder';
        if (firstMenu === 'placeholder') {
           this.$router.push('/user-center/placeholder');
        } else {
           this.$router.push(`/user-center/rights/${this.toKebabCase(firstMenu)}`);
        }
      } else {
        const routes = {
          'myRecord': '/user-center/my-record',
          'order': '/user-center/order',
          'invoice': '/user-center/invoice',
          'myConsultation': '/user-center/my-consultation',
          'activity': '/user-center/activity',
          // 'collection': '/user-center/collection', // 我的收藏：暂不开放
          'message': '/user-center/message'
        };
        const route = routes[tab.key] || '/user-center/placeholder';
        this.$router.push(route);
      }
    },

    /**
     * 处理标签页切换组件事件
     */
    handleTabChange(tabKey) {
      this.handleTabClick({ key: tabKey });
    },

    /**
     * 处理菜单点击
     * @param {Object} item 菜单项
     */
    handleMenuClick(item) {
      // 个人用户：只有实名认证完成后，企业身份认证页面才能点击
      if (this.$auth.hasPersonalType() && item.key === 'enterpriseAuth') {
        // isVerifiedPersonal: '0': 未认证, '1': 认证中, '2': 已认证, '3': 未通过
        if (this.isVerifiedPersonal !== '2') {
          ElMessage.warning(this.$t('userCenter.msg.completePersonalAuthFirst'))
          return
        }
      }
      this.isCreatingNewEnterprise = false
      this.$router.push(`/user-center/account/${this.toKebabCase(item.key)}`)
    },

    getEnterpriseIdentityId(ent) {
      return ent?.entId ?? ent?.enterpriseId ?? ent?.id ?? ''
    },
    getEnterpriseIdentityName(ent) {
      return ent?.entName || ent?.enterpriseName || ent?.name || ''
    },
    /**
     * 侧边栏选择企业：仅加载该企业详情表单（查看/修改），不做身份切换
     */
    handleSelectEnterprise(ent) {
      const entId = this.getEnterpriseIdentityId(ent)
      if (!entId) return

      this.isCreatingNewEnterprise = false
      this.selectedEnterpriseId = entId
      this.$router.push({
        path: '/user-center/account/enterprise-auth',
        query: { entId: String(entId) }
      })
    },
    /**
     * 认证新企业账号：打开空白认证表单（不做身份切换，避免整页跳转首页）
     */
    handleCreateNewEnterprise() {
      if (this.$auth.hasPersonalType() && this.isVerifiedPersonal !== '2') {
        ElMessage.warning(this.$t('userCenter.msg.completePersonalAuthFirst'))
        return
      }

      this.isCreatingNewEnterprise = true
      this.selectedEnterpriseId = null

      if (this.$route.path.includes('enterprise-auth') && this.$route.query.mode === 'create') {
        window.dispatchEvent(new CustomEvent('enterprise-auth-create-mode'))
        return
      }

      this.$router.push({
        path: '/user-center/account/enterprise-auth',
        query: { mode: 'create' }
      })
    },

    /**
     * 处理权益菜单点击
     * @param {Object} item 菜单项
     */
    handleRightsMenuClick(item) {
      if (['copyrightBusiness', 'inviteUser', 'educationTraining'].includes(item.key)) {
        //ElMessage.info(this.$t('userCenter.msg.underDevelopment'))
      }
      this.$router.push(`/user-center/rights/${this.toKebabCase(item.key)}`);
    },

    /**
     * 统一处理身份认证成功
     */
    async handleIdentitySubmitSuccess(data) {
      console.log('认证提交成功:', data);
      this.isCreatingNewEnterprise = false
      await this.loadUserInfo();
    },
    /**
     * 加载用户信息
     */
    async loadUserInfo() {
      try {
        this.isAssociationMember = false
        // 获取基础用户信息
        let data = await this.$auth.refreshMainBody()
        if (data) {
          // 公共用户信息（个人与企业共用）
          const defaultAvatar = require('@/assets/images/userDefaultAvatar.jpg')
          this.userInfo = {
            mainBodyId: data.mainBodyId,
            avatar: data.mainBodyAvatar || defaultAvatar,
            name: data.mainBodyName,
            createTime: data.mainBodyCreateTime,
            lastLoginTime: data.mainBodyLastLoginTime,
            mainBodyType: data.mainBodyType,
            enterpriseName: '',
            channelOrOrganizationName: ''
          }

          if (this.$auth.hasPersonalType()) {
            // 个人用户：获取个人详细信息
            try {
              const detailResponse = await getCurrentUserDetail()
              if (detailResponse && detailResponse.code === 200) {
                const mainBodyUser = detailResponse.data
                this.formData.avatar = mainBodyUser.avatar || defaultAvatar
                this.formData.nickName = mainBodyUser.nickName || ''
                this.formData.realName = mainBodyUser.realName || ''
                this.formData.phone = mainBodyUser.phone || ''
                this.formData.email = mainBodyUser.email || ''
                this.isVerifiedPersonal = mainBodyUser.isVerified
                this.personalUserOrdinaryAdminEnterpriseId = data.personalUserOrdinaryAdminEnterpriseId
                this.personalUserOrdinaryAdminEnterpriseName = data.personalUserOrdinaryAdminEnterpriseName
              }
            } catch (error) {
              console.error('获取个人详细信息失败:', error)
            }
          } else {
            // 企业用户：补充企业相关字段
            this.userInfo.enterpriseName = data.mainBodyName
            this.userInfo.channelOrOrganizationName = data.channelOrOrganizationName || ''
            this.isAssociationMember = this.$auth.isAssociationMember()
            if (this.isAssociationMember) {
              let response = await getMemberUnitInfoByEntId(data.mainBodyId)
              this.associationMemberStatus = response.data.showStatus
            }
          } 
          
            // 单独查询企业认证状态
            await this.loadEnterpriseVerificationStatus()
          // 检查当前路由是否在新的菜单列表中，如果不在则重置为第一个菜单项
          if (this.activeTab === 'account') {
            const currentMenuKeys = this.accountMenuItems.map(item => item.key)
            if (!currentMenuKeys.includes(this.activeMenu) && this.accountMenuItems.length > 0) {
              const firstMenu = this.accountMenuItems[0].key;
              if (this.$route.path !== `/user-center/account/${this.toKebabCase(firstMenu)}`) {
                this.$router.replace(`/user-center/account/${this.toKebabCase(firstMenu)}`)
              }
            }
          } else if (this.activeTab === 'rights') {
            const currentMenuKeys = this.rightsMenuItems.map(item => item.key)
            if (!currentMenuKeys.includes(this.activeRightsMenu) && this.rightsMenuItems.length > 0) {
              const firstMenu = this.rightsMenuItems[0].key;
              if (this.$route.path !== `/user-center/rights/${this.toKebabCase(firstMenu)}`) {
                this.$router.replace(`/user-center/rights/${this.toKebabCase(firstMenu)}`)
              }
            }
          }
        }
      } catch (error) {
        console.error('加载用户信息失败:', error)
      }
    },

    /**
     * 加载企业认证状态
     * 根据登录主体类型选择不同的接口：
     * - 个人主体：调用 getEnterpriseBySuperAdminId（返回企业数组）
     * - 企业主体：调用 getCurrentEnterprise（返回单个企业）
     */
    async loadEnterpriseVerificationStatus() {
      try {
        let response = null
        
        // 根据登录主体类型选择不同的接口
        if (this.$auth.hasEnterpriseType()) {
          // 企业主体：调用获取当前企业信息接口
          response = await getCurrentEnterprise()
        } else {
          // 个人主体：调用根据超级管理员ID获取企业信息接口（数组）
          response = await getEnterpriseBySuperAdminId()
        }
        
        if (response && response.code === 200 && response.data) {
          if (Array.isArray(response.data)) {
            const list = response.data
            // 侧边栏企业列表（查看/编辑用）
            this.enterpriseList = list
            const routeEntId = this.$route.query.entId
            if (routeEntId && list.some(item => String(item.id) === String(routeEntId))) {
              this.selectedEnterpriseId = routeEntId
            } else if (!this.selectedEnterpriseId && list.length && !this.isCreatingNewEnterprise) {
              this.selectedEnterpriseId = list[0].id
            }
            // 综合认证状态：任一已认证优先，其次认证中 / 未通过 / 未认证
            this.isVerifiedEnterprise = this.resolveEnterpriseListVerifiedStatus(list)
          } else {
            // 企业主体：单个对象
            this.enterpriseList = []
            this.isVerifiedEnterprise = response.data.isVerified || '0'
          }
        } else {
          // 如果没有企业信息，默认为未认证
          this.enterpriseList = []
          this.isVerifiedEnterprise = '0'
        }
      } catch (error) {
        console.error('加载企业认证状态失败:', error)
        // 出错时默认为未认证
        this.isVerifiedEnterprise = '0'
      }
    },

    /**
     * 从企业列表推导侧边栏展示用的综合认证状态
     * 优先级：已认证(2) > 认证中(1) > 未通过(3) > 未认证(0)
     * @param {Array} list
     * @returns {string}
     */
    resolveEnterpriseListVerifiedStatus(list) {
      if (!Array.isArray(list) || !list.length) return '0'
      if (list.some(item => String(item.isVerified) === '2')) return '2'
      if (list.some(item => String(item.isVerified) === '1')) return '1'
      if (list.some(item => String(item.isVerified) === '3')) return '3'
      return String(list[0].isVerified || '0')
    },

    /**
     * 获取企业认证状态文本
     * @param {string} status - 认证状态
     * @returns {string} 状态文本
     */
    getIsVerifiedText(status) {
      if (status === '0') {
        return this.$t('userCenter.verifyStatus.unverified')
      } else if (status === '1') {
        return this.$t('userCenter.verifyStatus.verifying')
      } else if (status === '2') {
        return this.$t('userCenter.verifyStatus.verified')
      } else if (status === '3') {
        return this.$t('userCenter.verifyStatus.rejected')
      } else {
        return this.$t('userCenter.verifyStatus.unverified')
      }
    },

    /**
     * 处理头像更新
     */
    handleAvatarUpdated(avatarUrl) {
      // 同步更新用户信息横幅中的头像
      this.userInfo.avatar = avatarUrl
      this.formData.avatar = avatarUrl
    },

    /**
     * 上传头像前的验证
     */
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        ElMessage.error(this.$t('userCenter.msg.avatarImageOnly'))
        return false
      }
      if (!isLt2M) {
        ElMessage.error(this.$t('userCenter.msg.avatarSizeLimit'))
        return false
      }
      return true
    },

    /**
     * 自定义头像上传
     */
    async handleAvatarUpload({ file }) {
      this.uploadingAvatar = true
      try {
        const formData = new FormData()
        formData.append('file', file)
        
        // 显示加载提示
        const loading = ElLoading.service({
          lock: true,
          text: this.$t('userCenter.msg.uploading'),
          background: 'rgba(0, 0, 0, 0.7)'
        })

        try {
          // 调用上传API
          const response = await uploadImage(formData)
          loading.close()
          
          if (response && response.code === 200) {
            const avatarUrl = response.data.originalUrl
            if (avatarUrl) {
              // 更新头像显示
              this.userInfo.avatar = avatarUrl
              this.formData.avatar = avatarUrl
              
              // 立即保存头像到用户信息
              await this.saveAvatar(avatarUrl)
              
              ElMessage.success(this.$t('userCenter.msg.avatarUploadSuccess'))
            }
          } else {
            loading.close()
            ElMessage.error(response.msg || this.$t('userCenter.msg.avatarUploadFail'))
          }
        } catch (apiError) {
          loading.close()
          throw apiError
        }
      } catch (error) {
        console.error('头像上传失败:', error)
        ElMessage.error(error.message || this.$t('userCenter.msg.avatarUploadFailRetry'))
      } finally {
        this.uploadingAvatar = false
      }
    },

    /**
     * 保存头像
     */
    async saveAvatar(avatarUrl) {
      try {
        const response = await updateCurrentAvatar(avatarUrl)
        
        if (response && response.code === 200) {
          // 更新表单数据
          this.formData.avatar = avatarUrl
          // 更新 auth 中的头像
          this.$auth.updateMainBodyAvatar(avatarUrl)
          // 触发全局头像更新事件，通知 CommonHeader 组件更新
          window.dispatchEvent(new CustomEvent('avatar-updated', {
            detail: { avatarUrl: avatarUrl }
          }))
        }
      } catch (error) {
        console.error('保存头像失败:', error)
      }
    },

    /**
     * 开始编辑昵称
     */
    startEditNickname() {
      this.isEditingNickname = true
      this.editNickname = this.formData.nickName || this.userInfo.name || ''
      this.originalNickname = this.editNickname
      // 聚焦输入框
      this.$nextTick(() => {
        const input = this.$el.querySelector('.nickname-input input')
        if (input) {
          input.focus()
          input.select()
        }
      })
    },

    /**
     * 保存昵称
     */
    async saveNickname() {
      if (!this.editNickname || this.editNickname.trim() === '') {
        ElMessage.error(this.$t('userCenter.msg.nicknameRequired'))
        return
      }

      if (this.editNickname === this.originalNickname) {
        // 没有变化，直接取消编辑
        this.cancelEditNickname()
        return
      }

      try {
        const response = await updateUserNickName(this.editNickname.trim())
        
        if (response && response.code === 200) {
          // 更新表单数据和显示
          this.formData.nickName = this.editNickname.trim()
          this.userInfo.name = this.editNickname.trim()
          this.originalNickname = this.editNickname.trim()
          this.isEditingNickname = false
          ElMessage.success(this.$t('userCenter.msg.nicknameSaveSuccess'))
          // 重新加载用户信息
          await this.loadUserInfo()
        } else {
          ElMessage.error(response.msg || this.$t('userCenter.msg.saveFail'))
        }
      } catch (error) {
        console.error('保存昵称失败:', error)
        ElMessage.error(this.$t('userCenter.msg.saveFailRetry'))
      }
    },

    /**
     * 取消编辑昵称
     */
    cancelEditNickname() {
      this.isEditingNickname = false
      this.editNickname = this.originalNickname
    },

    /**
     * 昵称输入框失焦处理
     */
    handleNicknameBlur() {
      // 延迟处理，以便点击保存按钮时不会立即取消
      setTimeout(() => {
        if (this.isEditingNickname) {
          // 如果输入框值没有变化，自动取消编辑
          if (this.editNickname === this.originalNickname) {
            this.cancelEditNickname()
          }
        }
      }, 200)
    },

  
    /**
     * 用户手动解除企业管理员身份
     */
    async handleExitEnterpriseAdmin() {
      try {
        const confirmed = await showEnhancedConfirmDialog(
          this.$t('userCenter.confirm.exitAdmin', {
            enterpriseName: `<span style="color: #0d62f3;">${this.personalUserOrdinaryAdminEnterpriseName}</span>`
          }),
          this.$t('userCenter.confirm.title'),
          this.$t('userCenter.confirm.ok'),
          this.$t('userCenter.cancel'),
          { dangerouslyUseHTMLString: true, type: 'warning' }
        )
        if (!confirmed) return

        const response = await exitEnterpriseAdmin(this.personalUserOrdinaryAdminEnterpriseId)
        if (response && response.code === 200) {
          ElMessage.success(response.msg)
          await this.$auth.refreshMainBody()
          await this.loadUserInfo()
        }
      } catch (error) {
        console.error('退出企业管理员失败:', error)
      }
    },

    /**
     * 打开加入渠道对话框
     */
    handleJoinChannel() {
      this.joinChannelDialogVisible = true
    },
    
    /**
     * 点击版权公益护航
     */
    handlePublicAction() {
      this.$router.push('/user-center/rights/copyright-public-action')
    },

    /**
     * 加入渠道成功回调
     */
    async handleJoinChannelSuccess() {
      // 刷新用户信息
      await this.loadUserInfo()
      // 刷新代理关系信息
      await this.loadProxyRelationInfo()
    },

    
    /**
     * 统一的渠道/机构操作处理方法
     * @param {string} type - 操作类型: 'exitChannel' 退出渠道, 'cancelChannelProxy' 取消渠道代理, 'exitInstitution' 退出机构
     */
     async handleChannelOperation(type) {
      // 操作类型配置
      const operationConfig = {
        exitChannel: {
          confirmText: this.$t('userCenter.confirm.exitChannel'),
          successText: this.$t('userCenter.msg.exitChannelSuccess'),
          errorLog: '退出渠道失败',
          apiMethod: clientQuit
        },
        cancelChannelProxy: {
          confirmText: this.$t('userCenter.confirm.cancelChannelProxy'),
          successText: this.$t('userCenter.msg.cancelChannelProxySuccess'),
          errorLog: '取消渠道代理失败',
          apiMethod: clientCancelChannelAgency
        },
        exitInstitution: {
          confirmText: this.$t('userCenter.confirm.exitInstitution'),
          successText: this.$t('userCenter.msg.exitInstitutionSuccess'),
          errorLog: '退出机构失败',
          apiMethod: clientQuit
        }
      }

      const config = operationConfig[type]
      if (!config) {
        console.error('未知的操作类型:', type)
        return
      }

      try {
        const confirmed = await showEnhancedConfirmDialog(
          config.confirmText,
          this.$t('userCenter.confirm.title'),
          this.$t('userCenter.confirm.ok'),
          this.$t('userCenter.cancel'),
          { type: 'warning' }
        )
        if (!confirmed) return

        if (!this.proxyRelationInfo.agentEntId) {
          ElMessage.error(this.$t('userCenter.msg.getEnterpriseIdFail'))
          return
        }
        
        const response = await config.apiMethod(this.proxyRelationInfo.agentEntId)
        if (response && response.code === 200) {
          ElMessage.success(config.successText)
          await this.loadProxyRelationInfo()
        }
      } catch (error) {
        console.error(config.errorLog + ':', error)
      }
    },

    /**
     * 加载代理关系信息
     * 获取用户是否授权机构代理、是否加入渠道、是否授权渠道代理
     */
    async loadProxyRelationInfo() {
      const initialProxyRelation = {
        hasAuthorizedProxy: false,
        hasJoined: false,
        agentEntName: '',
        agentEntType: '',
        agentEntId: null
      }
      try {
        const response = await getProxyRelationInfo()
        if (response && response.code === 200) {
          if (response.data) {
            const data = response.data
            // 只要有数据就表示已加入 根据 authStatus 和 agentEntType 判断代理关系
            this.proxyRelationInfo = {
              hasJoined: true,
              hasAuthorizedProxy: data.authStatus === '1',
              agentEntName: data.agentEntName,
              agentEntType: data.agentEntType,
              agentEntId: data.agentEntId
            }
          } else {
            // 无数据表示未加入渠道/机构，重置为初始状态
            this.proxyRelationInfo = { ...initialProxyRelation }
          }
        }
      } catch (error) {
        console.error('获取代理关系信息失败:', error)
        this.proxyRelationInfo = { ...initialProxyRelation }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-center {
  min-height: 100vh;
  padding-top: 84px; /* 为固定头部预留高度（与 header 一致） */
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* 用户信息横幅区域 */
.user-banner {
  background: linear-gradient(135deg, #2d3a5c 0%, #3d3229 100%);
  padding: 40px 0 50px;
  color: #ffffff;
  position: relative;
  overflow: hidden;

  // 添加右侧六边形图案背景
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 40%;
    height: 100%;
    background-image: 
      radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.03) 2px, transparent 2px),
      radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.03) 1.5px, transparent 1.5px),
      radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.03) 1.5px, transparent 1.5px);
    background-size: 40px 40px, 20px 20px, 20px 20px;
    background-position: 0 0, 10px 10px, 30px 30px;
    opacity: 0.4;
    pointer-events: none;
  }

  .user-banner-content {
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 30px;
    position: relative;
    z-index: 1;

    .last-login-row {
      position: absolute;
      top: 0;
      right: 30px;
      display: flex;
      align-items: center;
      gap: 24px;
      z-index: 2;
    }

    .last-login {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.85);
      white-space: nowrap;
    }

    .member-edit-wrapper {
      position: relative;
      display: inline-block;
    }

    .member-status-tag {
      position: absolute;
      left: 80%;
      bottom: calc(100% + 6px);
      transform: translateX(-50%);
      display: inline-block;
      padding: 4px 12px;
      border-radius: 24px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      font-style: normal;
      color: #333;
      text-align: justified;
      text-transform: none;
      white-space: nowrap;
      pointer-events: none;

      &--not-submitted {
        background: linear-gradient(93deg, #F37C0D 0%, #FFC48D 100%);
      }

      &--awaiting-review {
        background: linear-gradient(93deg, #F37C0D 0%, #FFC48D 100%);
      }

      &--passed {
        background: linear-gradient(93deg, #F37C0D 0%, #FFC48D 100%);
      }

      &--failed {
        background: linear-gradient(93deg, #F37C0D 0%, #FFC48D 100%);
      }

      /* 指向箭头：指向下方按钮 */
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -6px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #F37C0D;
      }

      &--not-submitted::after {
        border-top-color: #F37C0D;
      }

      &--awaiting-review::after {
        border-top-color: #F37C0D;
      }

      &--passed::after {
        border-top-color: #F37C0D;
      }

      &--failed::after {
        border-top-color: #F37C0D;
      }
    }

    .member-edit-btn {
      width: 118px;
      height: 38px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 0;
      border: none;
      border-radius: 24px;
      font-size: 14px;
      font-weight: 500;
      color: #5c4a32;
      cursor: pointer;
      background: linear-gradient(93deg, #DBB989 0%, #FFEECD 100%);
      box-shadow: inset 0 0 0 1px rgba(151, 105, 31, 0.18);
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.95;
      }

      .member-edit-icon {
        font-size: 14px;
      }
    }

    .user-profile {
      display: flex;
      align-items: flex-start;
      gap: 32px;
      padding-top: 0px;

      .user-avatar-wrapper {
        position: relative;
        display: inline-block;
        padding: 4px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          transform: translateY(-4px);
          background: rgba(255, 255, 255, 0.2);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
        }
        
        .user-avatar-large {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          border: 2px solid #ffffff;
          object-fit: cover;
          display: block;
        }

        .avatar-uploader {
          position: absolute;
          top: 4px;
          left: 4px;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          overflow: hidden;
          cursor: pointer;
          
          :deep(.el-upload) {
            width: 100%;
            height: 100%;
          }

          .avatar-edit-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            backdrop-filter: blur(2px);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: all 0.3s ease;
            border-radius: 50%;

            .edit-icon {
              font-size: 26px;
              color: #ffffff;
              margin-bottom: 4px;
            }

            .edit-text {
              font-size: 12px;
              color: #ffffff;
              font-weight: 500;
              letter-spacing: 1px;
            }
          }

          &:hover .avatar-edit-overlay {
            opacity: 1;
          }
        }
      }

      .user-basic-info {
        flex: 1;
        padding-top: 8px;
        
        .user-name-row {
          font-size: 18px;
          margin-bottom: 12px;
          color: #ffffff;
          line-height: 1.4;
          display: flex;
          align-items: center;
          
          .label {
            font-weight: 500;
            margin-right: 12px;
            color: rgba(255, 255, 255, 0.8);
            font-size: 16px;
          }
          
          .value {
            font-weight: 600;
            color: #ffffff;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }

          .nickname-display {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            margin-left: -6px;
            border-radius: 6px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: transparent;

            &:hover {
              background-color: rgba(255, 255, 255, 0.15);
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              
              .edit-icon-inline {
                opacity: 1;
                transform: scale(1.1);
              }
            }

            .edit-icon-inline {
              font-size: 16px;
              opacity: 0.6;
              transition: all 0.3s ease;
              color: #ffffff;
            }
          }

          .nickname-edit-wrapper {
            display: inline-flex;
            align-items: center;
            gap: 12px;
            background: rgba(255, 255, 255, 0.1);
            padding: 4px;
            border-radius: 8px;
            backdrop-filter: blur(4px);

            .nickname-input {
              width: 220px;
              
              :deep(.el-input__wrapper) {
                background-color: #ffffff !important;
                border: none !important;
                box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
                height: 36px;
                
                .el-input__inner {
                  color: #333 !important;
                  font-size: 16px !important;
                  font-weight: 600 !important;
                }
              }
            }

            .save-nickname-btn,
            .cancel-nickname-btn {
              height: 32px;
              font-size: 13px;
              font-weight: 500;
              border-radius: 4px;
              padding: 0 16px;
            }

            .save-nickname-btn {
              background-color: #0D62F3;
              border-color: #0D62F3;
              box-shadow: 0 2px 8px rgba(13, 98, 243, 0.3);

              &:hover {
                background-color: #1563e8;
                border-color: #1563e8;
                transform: translateY(-1px);
              }
            }

            .cancel-nickname-btn {
              background-color: rgba(255, 255, 255, 0.2);
              border: 1px solid rgba(255, 255, 255, 0.3);
              color: #ffffff;

              &:hover {
                background-color: rgba(255, 255, 255, 0.3);
                border-color: rgba(255, 255, 255, 0.5);
              }
            }
          }

          &.enterprise-name-row {
            align-items: flex-start;

            .enterprise-name-value {
              flex: 1;
              min-width: 0;
              word-break: break-word;
              overflow-wrap: anywhere;
            }
          }
        }

        .user-info-row {
          font-size: 15px;
          margin-bottom: 12px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 1.6;
          display: flex;
          align-items: center;
          
          .label {
            margin-right: 12px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.7);
          }
          
          .value {
            font-weight: 400;
            color: #ffffff;
          }
        }

        .vip-badges {
          display: flex;
          gap: 16px;
          margin-top: 22px;
          flex-wrap: wrap;
          
          .vip-badge {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.15);
            border: 2px solid rgba(255, 255, 255, 0.3);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: rgba(255, 255, 255, 0.25);
              border-color: #ffffff;
              transform: translateY(-5px) scale(1.05);
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
            }
          }
        }
      }
    }
  }
}

/* VIP会员广告卡片 */
.vip-banner-section {
  background-color: #f5f5f5;
  padding: 20px 0;

  .vip-banner-content {
    max-width: 1170px;
    margin: 0 auto;
    /* 不加水平 padding，与 .content-wrapper 左右边对齐 */

    .vip-card {
      background-color: #f5f5f5;
      background-image: url('@/assets/images/userCenter_vip_prompt.png');
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-origin: border-box;
      background-clip: border-box;
      border: 2px solid #e7c987;
      border-radius: 8px;
      box-sizing: border-box;
      height: 134px;
      padding: 20px 24px 20px 150px;
      display: flex;
      align-items: center;
      gap: 16px;
      position: relative;
      overflow: hidden;

      .vip-info {
        flex: 1 1 370px;
        min-width: 0;
        position: relative;
        z-index: 1;
        
        .vip-title {
          font-family: DingTalk JinBuTi, DingTalk JinBuTi;
          font-weight: 500;
          font-size: 23px;
          color: #584116;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 10px;
          white-space: nowrap;
        }

        .vip-subtitle {
          font-family: Noto Looped Thai UI, Noto Looped Thai UI;
          font-weight: 500;
          font-size: 15px;
          color: #7F6431;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .vip-benefits {
        display: flex;
        align-items: center;
        gap: 16px;
        position: relative;
        z-index: 1;
        flex: 0 1 auto;
        min-width: 0;
        transform: translateX(-58px);

        .vip-benefit {
          display: flex;
          align-items: center;
          gap: 10px;
          white-space: nowrap;

          .vip-benefit-icon {
            width: 38px;
            height: 38px;
            display: block;
            flex-shrink: 0;
            object-fit: contain;
          }

          .vip-benefit-title {
            font-size: 15px;
            font-weight: 400;
            color: #6a4f1d;
            line-height: 20px;
          }

          .vip-benefit-desc {
            margin-top: 2px;
            font-size: 12px;
            font-weight: 500;
            color: #8d713a;
            line-height: 16px;
          }
        }
      }

      .vip-btn {
        width: 140px;
        height: 46px;
        background: linear-gradient(90deg, #141C3C 0%, #363343 100%) !important;
        color: #dcbb7d !important;
        border: 1px solid transparent !important;
        box-shadow: 0 4px 4px 0 rgba(195, 165, 108, 0.5);
        border-radius: 6px;
        padding: 12px 18px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s;
        position: relative;
        z-index: 1;
        flex-shrink: 0;
        white-space: nowrap;

        .vip-btn-icon {
          margin-left: 8px;
          font-size: 16px;
          vertical-align: -2px;
        }

        &:hover {
          background: linear-gradient(90deg, #1a2550 0%, #424055 100%) !important;
          color: #dcbb7d !important;
          transform: translateY(-2px);
          box-shadow: 0 4px 4px 0 rgba(195, 165, 108, 0.5), 0 6px 12px rgba(0, 0, 0, 0.2);
        }

        &:focus {
          background: linear-gradient(90deg, #141C3C 0%, #363343 100%) !important;
          color: #dcbb7d !important;
        }
      }
    }
  }
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  padding: 30px 0;
  position: relative;

  .content-wrapper {
    max-width: 1170px;
    margin: 0 auto;
    position: relative;
  }
}

/* 左侧导航菜单 */
.sidebar-menu {
  position: absolute;
  left: -190px;
  top: 80px;
  width: 178px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 15px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  .menu-section {
    .menu-title {
      padding: 0 15px 12px;
      font-size: 13px;
      color: #1563e8;
      font-weight: 500;
    }

    .menu-item {
      padding: 10px 15px;
      font-size: 13px;
      color: #000000;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      justify-content: space-between;
      white-space: nowrap;
      min-width: 0;

      &:hover {
        background-color: #f5f7fa;
        color: #1563e8;
      }

      &.active {
        background-color: #ecf5ff;
        color: #1563e8;
        border-left: 3px solid #1563e8;
        font-weight: 500;
      }

      .menu-label {
        flex: 1;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .verify-status {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 10px;
        font-weight: normal;
        white-space: nowrap;
        flex-shrink: 0;
        margin-left: 8px;
        
        &.unverified {
          background-color: #ffffff;
          color: #999999;
          border: 1px solid #999999;
        }
        
        &.verifying {
          background-color: #409eff;
          color: #ffffff;
        }
        
        &.verified {
          background-color: #27AD60;
          color: #ffffff;
        }
        
        &.rejected {
          background-color: #F56C6C;
          color: #ffffff;
        }
      }
    }
  }

  .enterprise-identity-list {
    padding: 4px 12px 8px 20px;
  }

  .enterprise-identity-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f5f8ff;
    }

    &.selected {
      background-color: #ebf2ff;
    }

    .ent-radio {
      flex-shrink: 0;
      width: 14px;
      height: 14px;
      border: 1.5px solid #c0c4cc;
      border-radius: 50%;
      box-sizing: border-box;
      position: relative;

      &.checked {
        border-color: #1563e8;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #1563e8;
        }
      }
    }

    .ent-name {
      flex: 1;
      min-width: 0;
      font-size: 12px;
      color: #606266;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .logout-btn {
    margin: 15px 15px 0;
    width: calc(100% - 30px);
    background-color: #1563e8;
    color: #ffffff;
    border: none;
    padding: 8px;
    font-size: 13px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    display: block;

    &:hover {
      background-color: #1a6ef0;
    }

    // 当有多个按钮时，第一个按钮的 margin-top 保持，后续按钮的 margin-top 为 8px
    & + .logout-btn {
      margin-top: 8px;
    }
  }

  .create-enterprise-btn {
    margin-top: 15px;
  }

  // 解除管理员身份按钮：灰色描边，与渠道相关蓝色/橙色区分
  .exit-admin-btn {
    background-color: #ffffff;
    color: #606266;
    border: 1px solid #909399;

    &:hover {
      background-color: #f5f7fa;
      color: #606266;
      border-color: #909399;
    }

    &:focus {
      background-color: #ffffff;
      color: #606266;
      border-color: #909399;
    }
  }

  // 取消渠道代理按钮样式：更小、居中、橙色
  .cancel-proxy-btn {
    width: auto;
    min-width: 100px;
    padding: 6px 20px;
    font-size: 12px;
    background-color: #FF8C00;
    margin: 8px auto 0;
    display: block;

    &:hover {
      background-color: #FF7F00;
    }

    &:focus {
      background-color: #FF8C00;
    }
  }

  .channel-relation-text {
    margin: 8px 15px 0;
    font-size: 11px;
    color: #666666;
    text-align: center;
    line-height: 1.5;
  }
}

/* 右侧内容区域 */
.content-area {
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  min-width: 0;
  overflow: hidden; /* 防止英文长标签撑出白底卡片 */

  .tabs-nav {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    border-bottom: 1px solid #e4e7ed;
    background-color: #fafafa;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #dcdfe6;
      border-radius: 2px;
    }

    .tab-item {
      flex: 1 0 auto; /* 可均分，但不被压到比文案更窄；溢出时横向滚动 */
      padding: 15px 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      position: relative;
      transition: all 0.3s;
      white-space: nowrap;

      &:hover {
        color: #0D62F3;
      }

      &.active {
        color: #0D62F3;
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 3px;
          background-color: #0D62F3;
        }
      }
    }
  }


  :deep(.placeholder-content) {
    padding: 100px 40px;
    text-align: center;

    .placeholder-icon {
      font-size: 80px;
      color: #dcdfe6;
      margin-bottom: 20px;
    }

    .placeholder-text {
      font-size: 16px;
      color: #909399;
    }
  }
}

/* 响应式设计 */
/* 修复：在中等尺寸屏幕(1024px-1580px)下，由于 content-wrapper 居中导致绝对定位的左侧菜单(left: -190px)超出屏幕左侧。
   此处强制设置左边距，确保菜单可见，不再单纯居中。 */
@media (min-width: 1025px) and (max-width: 1580px) {
  .main-content .content-wrapper,
  .vip-banner-section .vip-banner-content {
    margin-left: 210px; /* 190px(菜单宽+间距) + 20px(安全距离) */
    margin-right: 20px;
    width: auto;
  }
}

@media (max-width: 1024px) {
  .main-content .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 15px;
    box-sizing: border-box;
    width: 100%;
  }

  .vip-banner-section .vip-banner-content {
    padding: 0 15px; /* 与 content-wrapper 左右对齐 */
  }

  .sidebar-menu {
    position: static;
    width: 100%;
    left: auto;
    top: auto;
    margin-bottom: 0;
  }
  
  .content-area {
    width: 100%;
    min-width: 0;
  }

  .vip-banner-section .vip-banner-content .vip-card {
    height: auto;
    min-height: 134px;
    flex-wrap: wrap;
    justify-content: center;
    padding: 20px;
    text-align: center;
    gap: 20px;

    .vip-info {
      flex: none;
      width: 100%;
      min-width: 0;

      .vip-title,
      .vip-subtitle {
        text-align: center;
      }

      .vip-title {
        white-space: normal;
      }
    }

    .vip-benefits {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 18px 28px;
      transform: none;
    }

    .vip-btn {
      width: 100%;
      max-width: 300px;
    }
  }

  .user-banner .user-banner-content {
    .last-login-row {
      position: static;
      flex-wrap: wrap;
      gap: 12px;
      justify-content: center;
      margin-bottom: 20px;
    }

    .last-login {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.6);
    }

    .user-profile {
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding-top: 0;
      gap: 24px;

      .user-avatar-wrapper {
        margin: 0 auto;
      }

      .user-basic-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;

        .user-name-row, .user-info-row {
          justify-content: center;
          width: 100%;
          gap: 8px;
          
          .label {
            width: auto;
            min-width: 70px;
            text-align: right;
            margin-right: 0;
          }
          
          .value {
            text-align: left;
            flex: 0 1 auto;
          }

          .nickname-display {
            margin-left: 0;
            padding: 4px 8px;
          }

          .nickname-edit-wrapper {
            justify-content: center;
            width: 100%;
            
            .nickname-input {
              width: 160px;
            }
          }
        }

        .enterprise-name-row {
          width: auto;
          max-width: 100%;
          flex-wrap: wrap;
          justify-content: center;
          text-align: center;

          .label {
            flex: 0 0 auto;
            min-width: 0;
            white-space: nowrap;
            text-align: center;
          }

          .enterprise-name-value {
            flex: 0 1 auto;
            max-width: 100%;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: anywhere;
            text-align: center;
          }
        }

        .vip-badges {
          justify-content: center;
          margin-top: 15px;
          gap: 12px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .user-center {
    padding-top: 64px;
  }

  .user-banner {
    padding: 30px 0;
  }

  .vip-banner-section {
    padding: 10px 0;
    
    .vip-banner-content {
      padding: 0 15px;
    }
  }

  .content-area .tabs-nav {
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
      display: none;
    }

    .tab-item {
      padding: 12px 15px;
      font-size: 13px;
      flex: 0 0 auto;
      min-width: 88px;
    }
  }

  .main-content {
    padding: 15px 0;
  }

  .main-content .content-wrapper {
    gap: 12px;
    padding: 0 12px;
  }

  .content-area {
    border-radius: 6px;
  }

  .sidebar-menu {
    border-radius: 6px;
    padding: 8px 0;

    .menu-section {
      display: flex;
      overflow-x: auto;
      padding: 5px 10px;
      gap: 10px;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        display: none;
      }

      .menu-item {
        padding: 8px 15px;
        background-color: #f5f7fa;
        border-radius: 20px;
        border: 1px solid #e4e7ed;
        flex-shrink: 0;
        justify-content: center;
        max-width: 180px;

        &.active {
          background-color: #ecf5ff;
          border-color: #1563e8;
          border-left: 1px solid #1563e8;
        }

        .verify-status {
          margin-left: 5px;
          padding: 1px 6px;
          font-size: 10px;
        }
      }
    }

    .logout-btn {
      width: calc(100% - 30px);
      margin: 10px 15px;
      margin-left: 15px;
      min-height: 38px;
      height: auto;
      box-sizing: border-box;
      white-space: normal;
      line-height: 1.35;
      word-break: break-word;
    }

    .channel-relation-text {
      margin-bottom: 10px;
    }
  }
}

@media (max-width: 480px) {
  .main-content .content-wrapper {
    padding: 0 8px;
  }

  .user-banner .user-banner-content {
    padding: 0 16px;

    .user-profile {
      .user-avatar-large {
        width: 100px;
        height: 100px;
      }

      .avatar-uploader {
        width: 100px;
        height: 100px;
      }

      .user-basic-info {
        .user-name-row {
          font-size: 16px;
        }
        .user-info-row {
          font-size: 14px;
        }
      }
    }
  }

  .vip-banner-section .vip-banner-content .vip-card {
    .vip-title {
      font-size: 20px;
      line-height: 28px;
    }
    .vip-subtitle {
      font-size: 14px;
      line-height: 22px;
    }
    .vip-benefits {
      gap: 14px;
    }
    .vip-benefit {
      width: 100%;
      justify-content: center;
    }
  }
}

/* 提交加载遮罩样式 */
:deep(.submit-loading) {
  border-radius: 8px;
  
  .el-loading-mask {
    border-radius: 8px;
  }
  
  .el-loading-spinner {
    .el-loading-text {
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
      margin-top: 10px;
    }
    
    .el-icon-loading {
      font-size: 42px;
      color: #1563e8;
    }
  }
}

</style>

